<template lang="pug">
    div.formSearch.fl_r
        div.icon
            include ../../snippets/search.pug

        select.selectLang(v-model="selected" @change="$emit('update', selected)")
            option(v-for="(option, i) in options" :value="option.id" :selected="i === 0") {{option.id}}

        input.inputSearch(type="text" v-model="search" placeholder="Поиск...")
    //formSearch
</template>

<script>
    import _ from 'lodash'
    export default {
        data() {
            return {
                search: '',
                selected: 'ru',
                options: [
                    {id: 'ru', text: 'Русский'},
                    {id: 'en', text: 'Английский'},
                    {id: 'he', text: 'Иврит'},
                    {id: 'cir', text: 'Джуури (лат)'},
                    {id: 'lat', text: 'Джуури (кир)'}
                ]
            }
        },
        methods: {
            //onChange() {this.$emit('update', this.selected);}
        },
        watch: {
            search: _.debounce(async function (value) {
                const route = {name: this.$route.name};

                if (this.search !== '') {
                    route.query = {search: this.search}
                }
                this.$router.push(route)
            }, 700),
            '$route.query.search': {
                immediate: true,
                handler(value) {
                    this.search = value
                }
            }
        },
        computed: {
            getValue() {
                return this.$emit('update', this.selected);
            }
        }
    }
</script>
